import { NavigationProp, useNavigation } from "@react-navigation/native";
import MainContainer from "components/MainContainer";
import Switch from "components/Switch";
import { AccountStackParamList } from "navigation/types";
import React, { useState } from "react";
import { View } from "react-native";
import BaseCard, { BaseCardListItem } from "components/BaseCard";
import { useAccount } from "hooks/useAccount";
import { useMutation } from "@tanstack/react-query";
import { updateAccountFetcher } from "queries/account.queries";
import i18n from "plugins/localization";
import Spacer from "components/Spacer";

const Settings = () => {
  const navigation = useNavigation<NavigationProp<AccountStackParamList>>();
  const { account, fetchAccount } = useAccount();
  const { mutateAsync: updateAccount } = useMutation(updateAccountFetcher);

  const [includeAccessibleToggle, setIncludeAccessibleToggle] = useState(
    account?.seatPreference === "INCLUDE_ACCESSIBLE"
  );
  const handleIncludeAccessible = async (value: boolean) => {
    setIncludeAccessibleToggle(value);
    await updateAccount({
      seatPreference:
        account!.seatPreference === "NONE" ? "INCLUDE_ACCESSIBLE" : "NONE",
      marketplace: account!.marketplace,
    });
    fetchAccount();
  };

  if (!account) return null;

  return (
    <MainContainer
      goBackAction={() => navigation.navigate("AccountScreen")}
      title={i18n.t("screens.Settings.settings")}
      grayBackground
    >
      <View style={{ padding: 15 }}>
        <BaseCard title={i18n.t("screens.Settings.settings")}>
          <BaseCardListItem
            title={i18n.t("screens.Settings.includeAccessible")}
            description={i18n.t(
              "screens.Settings.includeAccessibleDescription"
            )}
            accessoryRight={
              <Switch
                testID="include-accessible-switch"
                checked={includeAccessibleToggle}
                onChange={handleIncludeAccessible}
              />
            }
            onPress={() => handleIncludeAccessible(!includeAccessibleToggle)}
          />
        </BaseCard>

        <Spacer />

        {/* <BaseCard title={i18n.t("screens.Settings.language")}>
          <BaseCardListItem title={<LanguageSelector />} showArrow={false} />
        </BaseCard> */}
      </View>
    </MainContainer>
  );
};

export default Settings;
